function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";
import { AcquisitionPopupContainerDisplay, query } from "~/components/acquisition-popup-container/display";
export const AcquisitionPopupContainer = props => {
  const [queryReference, loadQuery, disposeQuery] = useQueryLoader(query);
  useEffect(() => {
    loadQuery({});
    return disposeQuery;
  }, [loadQuery, disposeQuery]);
  return /*#__PURE__*/React.createElement(Suspense, {
    "data-qa": "acquisition-popup-container"
  }, queryReference && /*#__PURE__*/React.createElement(AcquisitionPopupContainerDisplay, _extends({}, props, {
    queryReference: queryReference
  })));
};
AcquisitionPopupContainer.displayName = "AcquisitionPopupContainer";